import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  map: {
    height: '350px',
    width: '100%'
  }
});
